// @flow
import React, { Component } from 'react';
import _ from 'lodash';
import { Progress } from 'semantic-grab-ui/src';

type Props = {
  label: string,
  usage: number,
  limit: number
};

class ProgressBar extends Component<Props> {
  render() {
    const { label, usage, limit } = this.props;

    // Function to display numbers with currency
    const formatCurrency = (value) => `${_.round(value).toLocaleString()}`;

    // Set color based on remaining budget
    let color = 'green';
    if (usage >= limit) {
      color = 'red';
    } else if (usage / limit > 0.7) {
      color = 'orange';
    }

    return (
      <React.Fragment>
        <label style={{ color: '#898d97', fontSize: 12, fontWeight: 'bold' }}>{label}</label>
        <div>
          <p style={{ fontSize: 12, textAlign: 'right', marginBottom: 5, marginTop: 10 }}>
            <strong>{formatCurrency(usage)}</strong> / {formatCurrency(limit)}
          </p>
          <Progress value={usage} total={limit} color={color} size={'small'} />
        </div>
      </React.Fragment>
    );
  }
}

export default ProgressBar;
